// Copyright (c) 2017 Deere & Company

import Accordion from '../../../shared/components/smart-accordion/state/accordion';
import t from 'tcomb';

const AccordionList = t.struct({
    accordionList: t.list(Accordion)
}, 'AccordionList');

export const getDefaultState = () => new AccordionList({
    accordionList: [
        {
            accordionId: 'SELECTED_FOR_AUDIT',
            isExpanded: false
        },
        {
            accordionId: 'CLAIM_DRAFT',
            isExpanded: false
        },
        {
            accordionId: 'NEW',
            isExpanded: false
        },
        {
            accordionId: 'REJECTED_APPEAL',
            isExpanded: false
        },
        {
            accordionId: 'DEALER_INVOICE_UPDATED',
            isExpanded: false
        },
        {
            accordionId: 'RECONCILED',
            isExpanded: false
        },
        {
            accordionId: 'SUBMITTED',
            isExpanded: false
        },
        {
            accordionId: 'SUBMITTED_AVAILABLE_TO_EDIT',
            isExpanded: false
        },
        {
            accordionId: 'APPROVED',
            isExpanded: false
        },
        {
            accordionId: 'REJECTED',
            isExpanded: false
        },
        {
            accordionId: 'DELETED',
            isExpanded: false
        },
        {
            accordionId: 'FORWARDED',
            isExpanded: false
        },
        {
            accordionId: 'RETURNED',
            isExpanded: false
        },
        {
            accordionId: 'REVISED',
            isExpanded: false
        },
        {
            accordionId: 'DEBITED',
            isExpanded: false
        },
        {
            accordionId: 'WAITING_FOR_DLR_INV',
            isExpanded: false
        }]
});

export default AccordionList;



// WEBPACK FOOTER //
// ./src/claim/all-claims/state/accordion-list.js